<div class="tango-wrapper">
  <div class="container">
    <h1>
      Do you want to quickly turn real-time feedback into insights?
      Check out  <a href="/assessments/assessments-list" style="color: #37B1D4; text-decoration: underline; font-size: 16px;" target="_blank"> ISG Assessments</a>
      – our all-in-one platform that collects, analyzes and visualizes data. 
    </h1>
    <!--<a style="color: #bebebe; text-decoration: none; font-size: 16px;" target="_blank" href="https://learning.ultipro.com/7954290/isg-tango-training">https://learning.ultipro.com/7954290/isg-tango-training</a>-->
    <!--<a style="color: #bebebe; text-decoration: none; font-size: 16px;" target="_blank" href="https://learning.ultipro.com/8553213/isg-tango-demo-updates">https://learning.ultipro.com/8553213/isg-tango-training</a>-->
    <div class="logo" style="margin-left:35px; ">
      <img src="../../../../../../assets/images/workbench/ISG_Assessments.png" alt="ISG Assessment">
    </div>
    <p>Contact us at  <a href="mailto:assessment.support@isg-one.com  " style="color: #03ABBA; text-decoration: none; font-size: 16px;" target="_blank">assessment.support&#64;isg-one.com</a>  </p>
  </div>
</div>
